import { BaseDiv } from "./BaseDom";
import videojs, { VideoJsPlayer } from "video.js";
import { IOptions } from "../type";

export default class ProfileBox extends BaseDiv {
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player);
    this.addClass("vjs-profile-box");
    const top = opts?.top || 0;
    const left = opts?.left || 0;
    const width = opts?.width || 100;
    videojs.registerComponent("ProfileHead", ProfileHead);
    videojs.registerComponent("ProfileFoot", ProfileFoot);
    this.setStyle({
      top: `${top}px`,
      left: `${left}px`,
      width: `${width}px`,
      position: "absolute",
    });
    this.addChild("ProfileHead", opts);
    this.addChild("ProfileFoot", opts);
  }
}

class ProfileHead extends BaseDiv {
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player);
    const entity = opts?.entity || "未命名";
    const score = (opts?.score || 0) as number;
    const color = (opts?.color || "#000") as string;
    videojs.dom.appendContent(this.el(), `${entity}: ${score * 100}%`);
    this.setStyle({
      width: "100%",
      border: `1px solid ${color}`,
      background: color,
      "font-size": "20px",
      "line-height": "20px",
      "text-align": "center",
    });
  }
}

class ProfileFoot extends BaseDiv {
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player);
    const color = opts?.color || "#000";
    const height = opts?.height || 200;
    this.setStyle({
      width: "100%",
      border: `1px solid ${color}`,
      height: `${height}px`,
    });
  }
}
